// Module
var code = "<div data-bind=\"click: $root.ShowControlEditor.bind($root, $data), preventBubble: ['click'], css: GetWrapperClass()\" class=\"form-custom-control\" title=\"\"> <!-- ko template: { name: GetDesignTemplateName.bind($rawData), afterRender: $rawData.AfterRender.bind($rawData) } --><!-- /ko --> </div>";
// Exports
export default code;